import { render, staticRenderFns } from "./BonusButton.vue?vue&type=template&id=6ae80572&scoped=true&"
import script from "./BonusButton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BonusButton.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BonusButton.vue?vue&type=style&index=0&id=6ae80572&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae80572",
  null
  
)

export default component.exports